import React, { useEffect } from "react";
import propTypes from "prop-types";
import $ from "jquery";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import modelObj from "../../../utils/cookieUtils";

import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons

const types = {
    title: propTypes.string,
    titleStyle: propTypes.object,
    id: propTypes.string,
    name: propTypes.string,
    value: propTypes.any,
    setValue: propTypes.func,
    options: propTypes.array,
    size: propTypes.number,
    placeHolder: propTypes.string,
};

MultiSelector.propTypes = types;
SingleSelector.propTypes = types;

MultiCheckBox.propTypes = types;

export function MultiSelector({
    title,
    titleStyle,
    id,
    name,
    value,
    setValue,
    options,
    size,
    placeHolder,
    dataLang,
    useLang,
    teamId
}) {
    useEffect(() => {
        modelObj.renderLanguage();
    }, [dataLang]);

    return (
        <>
            <div
                className="input-group"
                style={{ marginTop: "5px", flexWrap: "nowrap", height: "40px" }}
            >
                <div className="input-group-prepend select-Title">
                    <span
                        className="input-group-text"
                        data-lang={dataLang}
                        style={{ width: "90px" }}
                    >
                        {title}
                    </span>
                </div>
                <MultiSelect
                    id={id}
                    value={value}
                    options={options}
                    onChange={setValue}
                    name={name}
                    style={{ width: "92%", alignItems: "center", overflow: "hidden" }}
                    placeholder={placeHolder}
                    optionLabel={useLang === "en" 
                            ? (teamId == 0 ? "fullEngName" : "engName") 
                            : (teamId == 0 ? "fullLabel" : "label")}
                ></MultiSelect>
            </div>
        </>
    );
}

export function SingleSelector({
    title,
    titleStyle,
    id,
    name,
    value,
    setValue,
    options,
    placeHolder,
    dataLang,
    useLang,
}) {
    return (
        <>
            <div
                className="input-group"
                style={{ flexWrap: "nowrap", height: "40px" }}
            >
                <div className="input-group-prepend select-Title">
                    <span
                        className="input-group-text"
                        data-lang={dataLang}
                        style={{ width: "90px" }}
                    >
                        {title}
                    </span>
                </div>
                <Dropdown
                    id={id}
                    value={value}
                    options={options}
                    onChange={setValue}
                    name={name}
                    placeholder={id == "teamId" ? "팀 선택" : "상대팀 선택"}
                    style={{ width: "92%", alignItems: "center" }}
                    optionLabel={useLang === "en" ? "engTeamName" : "label"}
                ></Dropdown>
            </div>
        </>
    );
}

export function GameTypeSelector({
    title,
    titleStyle,
    id,
    name,
    value,
    setValue,
    options,
    placeHolder,
    dataLang,
    useLang,
}) {
    return (
        <>
            <div
                className="input-group"
                style={{ flexWrap: "nowrap", height: "40px" }}
            >
                <div className="input-group-prepend select-Title">
                    <span
                        className="input-group-text"
                        data-lang={dataLang}
                        style={{ width: "90px" }}
                    >
                        {title}
                    </span>
                </div>
                <Dropdown
                    id={id}
                    value={name == "seasons" ? ((value == undefined || value == null || value == [] || value == "") ? "" : value[0]) : value}
                    options={options}
                    onChange={setValue}
                    placeholder={name == "seasons" ? "시즌 선택" : "선수유형 선택"}
                    name={name}
                    style={{ width: "92%", alignItems: "center" }}
                    optionLabel={useLang === "en" ? "dataLang" : "label"}
                ></Dropdown>
            </div>
        </>
    );
}

export function GameTypeMultiSelector({
    title,
    titleStyle,
    id,
    name,
    value,
    setValue,
    options,
    size,
    placeHolder,
    dataLang,
    useLang,
}) {
    useEffect(() => {
        modelObj.renderLanguage();
    }, [dataLang]);

    return (
        <>
            <div
                className="input-group"
                style={{ flexWrap: "nowrap", height: "40px" }}
            >
                <div className="input-group-prepend select-Title">
                    <span
                        className="input-group-text"
                        data-lang={dataLang}
                        style={{ width: "90px" }}
                    >
                        {title}
                    </span>
                </div>
                <MultiSelect
                    id={id}
                    value={value}
                    options={options}
                    onChange={setValue}
                    name={name}
                    style={{ width: "92%", alignItems: "center", overflow: "hidden" }}
                    placeholder={placeHolder}
                    optionLabel={useLang === "en" ? "engName" : "label"}
                ></MultiSelect>
            </div>
        </>
    );
}

export function MultiCheckBox({
    title,
    titleStyle,
    id,
    name,
    value,
    setValue,
    options,
    size,
    placeHolder,
    dataLang,
    useLang,
}) {
    useEffect(() => {
        //criteria에 저장된 값을 이용해 스타일 유지
        initialDetailStyle();
    }, []);

    const initialDetailStyle = () => {
        //스타일 설정
        var detailMenuName = $("[name='" + name + "']");
        detailMenuName.each(function (item, contents) {
            if (value?.length > 0) {
                if(id == "minBallSpeed" || id == "maxBallSpeed"){
                    if ($(contents).attr("value") === value) {
                        $(contents).addClass("active");
                    }
                } else {
                    value.forEach(function (val) {
                        if ($(contents).attr("value") === val) {
                            $(contents).addClass("active");
                        }
                    });
                }
            }
        });
    };

    return (
        <>
            <div className="input-group">
                <div className="input-group-prepend select-Title multiCheckbox-Title">
                    <span
                        className="input-group-text"
                        data-lang={dataLang}
                        style={{ width: "100px" }}
                    >
                        {title}
                    </span>
                </div>

                <div
                    id={id}
                    className="form-control multiCheckbox"
                    style={{ height: "auto", wordWrap: "break-word" }}
                >
                    {options ? (
                        options.map((option, idx) => {
                            return (
                                <span
                                    data-lang={option.dataLang}
                                    className="select-detail-criteria"
                                    onClick={setValue}
                                    name={name}
                                    value={option.value}
                                    key={idx}
                                >
                                    {option.label}
                                </span>
                            );
                            //만약에 언어가 영어일 경우
                            // if (useLang === "en") {
                            //     return (
                            //         <span
                            //             data-lang={option.dataLang}
                            //             className="select-detail-criteria"
                            //             onClick={setValue}
                            //             name={name}
                            //             value={option.value}
                            //             key={idx}
                            //         >
                            //             {option.label}
                            //         </span>
                            //     );
                            // } else {
                            //     //만약에 언어가 한국어일 경우
                            //     return (
                            //         <span
                            //             data-lang={option.dataLang}
                            //             className="select-detail-criteria"
                            //             onClick={setValue}
                            //             name={name}
                            //             style={{
                            //                 whiteSpace: "nowrap",
                            //             }}
                            //             value={option.value}
                            //             key={idx}
                            //         >
                            //             {option.label}
                            //         </span>
                            //     );
                            // }
                        })
                    ) : (
                        <span value={0}>{placeHolder}</span>
                    )}
                </div>
            </div>
        </>
    );
}
